{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
CreateOrgView = require 'app/scripts/views/organization/create-org-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'

module.exports = class NewBoardHelperAddOrgView extends View
  viewTitleKey: 'add an organization'

  events:
    'click .js-create-org': 'newOrg'

  render: ->
    view = @
    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/popover_helper_new_board_add_org')
      )
    )

    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendScreenEvent
        name: 'newBoardHelperAddOrganizationInlineDialog'
    @

  newOrg: (e) ->
    createOpts = {}

    if Auth.me().isPaidManagedEntMember()
      createOpts.isEnterprise = true

    Util.stop(e)
    trackingOpts = { category: 'board', method: 'by clicking team info icon in copy board menu' }
    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, trackingOpts })
